import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getDevice } from '../../helpers';
import Checkbox from '../Input/InputCheckbox';
import { select } from '../../core/themev2';
import { getColor } from '../../core/themev3';
import urbaniaAdondevivir from '../../assets/img/urbania_adondevivir.svg';

const TermsAndConditionsModal = ({ onClose, handleDispatch }) => {
  const device = getDevice();
  const { t } = useTranslation();
  const [checked, setChecked] = useState({ terms: false, policies: false });
  const enabledButtonCTA = checked.terms && checked.policies ? checked : null;

  const termsAndConditionsInfo = [
    {
      id: 1,
      link: 'https://help.urbania.pe/es/articles/3606316-terminos-y-condiciones-de-uso',
      link2: 'https://help.urbania.pe/es/articles/3608394-terminos-y-condiciones-generales-de-contratacion',
      textKey: 'terms',
      textKey2: 'terms2'
    },
    { id: 2, link: 'https://help.urbania.pe/es/articles/3606317-politica-de-privacidad', textKey: 'policies' }
  ];

  const handleClickCheckbox = name => {
    setChecked({
      ...checked,
      [name]: !checked[name]
    });
  };

  const handleCTA = () => {
    if (enabledButtonCTA) {
      handleDispatch();
      onClose();
    }
    return null;
  };

  return (
    <Container device={device}>
      <Img src={urbaniaAdondevivir} data-panel='panel-termsAndConditions-image' />
      <div>
        <h3 data-panel='panel-termsAndConditions-title'>{t('panel.termsAndConditions.modal.title')}</h3>
        <p data-panel='panel-termsAndConditions-text'>{t('panel.termsAndConditions.modal.text')}</p>
      </div>
      <div className='terms'>
        {termsAndConditionsInfo.map(item => (
          <CheckboxRow key={item.id} data-panel={`panel-termsAndConditions-${item.textKey}`} device={device}>
            <div onClick={() => handleClickCheckbox(item.textKey)} aria-hidden='true'>
              <Checkbox
                name={item.textKey}
                checked={checked[item.textKey]}
                fillColor={getColor('primary')}
                readOnly
                cursorType='pointer'
                margin='2px 5px 4px 0px'
              />
            </div>
            <div className='row-info' data-panel={`panel-termsAndConditions-${item.textKey}-text`}>
              {t(`panel.termsAndConditions.modal.pre.${item.textKey}`)}{' '}
              <a href={item.link} target='_blank' rel='noopener noreferrer'>
                {t(`panel.termsAndConditions.modal.${item.textKey}`)}
              </a>
              {item.textKey2 && (
                <>
                  {' '}
                  {t(`panel.termsAndConditions.modal.pre.${item.textKey2}`)}{' '}
                  <a href={item.link2} target='_blank' rel='noopener noreferrer'>
                    {t(`panel.termsAndConditions.modal.${item.textKey2}`)}
                  </a>
                </>
              )}
            </div>
          </CheckboxRow>
        ))}
      </div>
      <CTA onClick={() => handleCTA()} enabled={enabledButtonCTA} data-panel='panel-termsAndConditions-buttonCTA'>
        {t('panel.termsAndConditions.modal.cta')}
      </CTA>
    </Container>
  );
};

const Container = styled.div`
  padding: 24px;
  box-sizing: border-box;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  h3 {
    font-family: Hind;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    text-align: center;
    white-space: normal;
  }
  p {
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    white-space: normal;
    margin-top: 16px;
  }
  .terms {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    flex-direction: column;
    gap: ${({ device }) => (device === 'desktop' ? '9px' : '11px')};
    align-self: flex-start;
    width: 100%;
  }
  .row-info {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: ${({ device }) => (device === 'desktop' ? 'normal' : '26px')};
    margin: 0;
    display: block;
    white-space: break-spaces;
  }
  a {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    color: ${select('black')};
    cursor: pointer;
  }
`;

const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ device }) => (device === 'desktop' ? '4px' : '15px')};
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: cover;
  width: 247px;
  height: 32px;
`;

const CTA = styled.button`
  height: 48px;
  width: 100%;
  border-radius: 8px;
  color: ${select('midNeutralGray')};
  background-color: ${select('neutralGray')};
  text-align: center;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  text-align: center;
  margin-top: 4px;
  padding: 0 12px;
  cursor: auto;
  ${({ enabled }) =>
    enabled &&
    css`
      background-color: ${getColor('primary')};
      color: ${select('white')};
      cursor: pointer;
      :hover {
        background-color: ${getColor('secondary')};
      }
    `};
`;

export { TermsAndConditionsModal };
